import React from 'react';
import './Homepage.css';

export default function Homepage() {
	return (
		<div className='homepage-container'>
			<h1>Welcome to EduBase(Name in progress!)</h1>
		</div>
	);
}
